import React, { useEffect, useState } from "react";
import moment from "moment";
import { Accordion, Icon } from "semantic-ui-react";
import PaymentsList from "../paymentPlan-card/payments-accordion/payments-list/PaymentsList";
import PaymentHistoryList from "../paymentPlan-card/payment-history-accordion/payment-history-list/PaymentHistoryList"
import Utilities from "../../../../../../services/commonservice/utilities";
import InvoicePreview from "../../../invoices/invoice-preview/InvoicePreview";
import RecurringPlanButtonGroup from "../../../../../../services/commonservice/recurring-button-group.utility";

const PaymentPlanCard = (props) => {
    const [showMore, setShowMore] = useState(false);
    const [activeIndex, setActiveIndex] = useState();
    const [paymentPlan, setPaymentPlan] = useState(props.paymentPlan);
    const setIndex = (i) => {
        if (i === activeIndex) {
            setActiveIndex();
        } else {
            setActiveIndex(i);
        }
    };

    useEffect(() => {
        setPaymentPlan(props.paymentPlan);
    }, [props.paymentPlan])

    return (
        <div className='container-flex card mb-3 bg-light'>
            {paymentPlan &&
                <div className='row d-flex p-3'>
                    <div className='col-12 row-fluid d-flex justify-content-between'>
                        <div className='col-12 row d-flex align-items-start'>
                            <div className='col-md-8 col-12 btn text-start' onClick={e => { e.preventDefault(); setShowMore(!showMore) }}>
                                <h5 className='mt-2'>{paymentPlan.invoiceNumber ? `${paymentPlan.invoiceNumber} | ` : null}{paymentPlan.firstName} {paymentPlan.lastName}
                                </h5>
                                <div className='row'>
                                    {props.type == 3 ?
                                        <div className="col-md-6 col-12"><span className="w-150px"><strong>Total</strong></span>{paymentPlan.noOfPayments} of payments {Utilities.toDollar(paymentPlan.paymentAmount)}</div> : <span className='col-md-6 col-12'><span className="w-150px"><strong>Total</strong></span>{Utilities.toDollar(paymentPlan.totalAmount ? paymentPlan.totalAmount : 0)}</span>}
                                    {props.type == 3 ? <span className='col-md-6 col-12'><span className="w-150px"><strong>Remaining Balance</strong></span>{paymentPlan.totalPaymentLeft} payments of {Utilities.toDollar(paymentPlan.paymentAmount)}</span> : <span className='col-md-6 col-12'><span className="w-150px"><strong>Remaining Balance</strong></span>{Utilities.toDollar(paymentPlan.totalDueAmount ? paymentPlan.totalDueAmount : 0)}</span>}
                                    {/* <span className='col-md-6 col-12'><span className="w-150px"><strong><i className='icon clipboard' />Payment Type</strong></span> {InvoiceTypeEnum[paymentPlan.transactionType]}</span> */}
                                </div>
                                <div className='row'>
                                    {paymentPlan.createdOn && <span className='col-md-6 col-12'><span className="w-150px"><strong>Created On</strong></span> {moment(paymentPlan.createdOn).format("M/D/YYYY")}</span>}
                                    {paymentPlan.nextTransactionDate && <span className='col-md-6 col-12'><span className="w-150px"><strong>Next Transaction Date</strong></span> {moment.utc(paymentPlan.nextTransactionDate).format("M/D/YYYY")}</span>}
                                </div>
                            </div>

                            <div className='col-md-4 col-12 d-flex justify-content-end'>
                            <div className="btn-group">
                                    <RecurringPlanButtonGroup
                                        //buttonClass={'p-0 ps-1'}
                                        initialData={paymentPlan}
                                        //extraButton={extraButtons}
                                        showPaymentHistory={false}
                                        showUpcomingPayments={false}
                                        refresh={() => { props.refresh() }}
                                    ></RecurringPlanButtonGroup>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showMore && <div className='mt-3'>
                        <Accordion fluid styled>
                            <Accordion.Title
                                active={activeIndex === 0}
                                index={0}
                                onClick={e => { e.preventDefault(); setIndex(0) }}
                            > <Icon name='dropdown' />Preview</Accordion.Title>
                            <Accordion.Content active={activeIndex === 0}>
                                {activeIndex === 0 && <InvoicePreview invoiceId={paymentPlan.invoiceId} pull={activeIndex === 0} />}
                            </Accordion.Content>

                            <Accordion.Title
                                active={activeIndex === 1}
                                index={1}
                                onClick={e => { e.preventDefault(); setIndex(1) }}
                            > <Icon name='dropdown' />Upcoming Payments</Accordion.Title>
                            <Accordion.Content active={activeIndex === 1}>
                                {activeIndex === 1 && <PaymentsList paymentPlanId={paymentPlan.id} pull={activeIndex === 1} />}
                            </Accordion.Content>

                            <Accordion.Title
                                active={activeIndex === 2}
                                index={2}
                                onClick={e => { e.preventDefault(); setIndex(2) }}
                            > <Icon name='dropdown' />Payment History{activeIndex === 2 && <Icon name="plus" style={{ float: 'right' }} title="Add Subscription Details" className='btn p-2' onClick={e => { e.preventDefault(); setMembershipAdd(true) }} />}</Accordion.Title>
                            <Accordion.Content active={activeIndex === 2}>
                                {activeIndex === 2 && <PaymentHistoryList paymentPlanId={paymentPlan.id} paymentPlan={paymentPlan} refresh={() => { if(props.refresh) props.refresh() }} pull={activeIndex === 2} />}
                            </Accordion.Content>
                        </Accordion>
                    </div>}
                </div>
            }
        </div>
    );
};

export default PaymentPlanCard;
